export const FETCH_SWIMMERS = "swimmers/fetch"
export const ADD_SWIMMERS = "swimmers/add"

export const SELECT_SWIMMER = "swimmer/select"
export const PATCH_SWIMMER = "swimmer/patch"